<template>
  <v-app id="mainWindow" class="dt-theme" :class="appThemeClass">
    <v-navigation-drawer
      :class="mainNavClass"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      :value="true"
      stateless
      :width="200"
      disable-resize-watcher
      fixed
      app
    >
      <div class="ut-fc ut-fh ut-jbetween">
        <!-- <h1>Safiqul</h1> -->

        <!-- mdsir nav -->
        <LeftNavigationComponent
          :items="items"
          :value="appDrawer"
          @closeMainNav="onCloseMainNav"
        />
        <div class="ut-flex ut-rowcen">
          <v-menu v-if="false" offset-y class="bl-more-menu" open-on-hover>
            <div class="dt-icon-container" @click="onUserFeedbackClick" slot="activator">
              <img
                class="dt-icon v5"
                style="width: 70px; height: 70px"
                src="static/icons/user-feedback.svg"
              />
            </div>

            <!-- <v-list class="filter-more-options-list">
              <v-list-tile
                class="options-item"
                v-for="(item, index) in userFeedBackItems"
                :key="index"
                @click="(e) => onUserFeedbackItemClick(item)"
              >
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list> -->
          </v-menu>
        </div>
        <div
          class="version-info"
          tabindex="10"
          :class="{ visible: versionInfoVisible }"
          @keyup="onVersionInfoKeyup"
        >
          <table v-if="buildinfo.version && versionInfoVisible">
            <tr>
              <td>Version</td>
              <td :title="buildinfo.version">{{ buildinfo.version }}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td :title="new Date(buildinfo.date).toLocaleString()">
                {{ new Date(buildinfo.date).toLocaleString() }}
              </td>
            </tr>
            <tr>
              <td>Build No</td>
              <td :title="buildinfo.buildno">{{ buildinfo.buildno }}</td>
            </tr>
            <tr>
              <td>Hash</td>
              <td :title="buildinfo.hash">{{ buildinfo.hash }}</td>
            </tr>
            <tr>
              <td>Checksum</td>
              <td :title="buildinfo.checksum">{{ buildinfo.checksum }}</td>
            </tr>
          </table>
        </div>
        <!-- <div
          class="feedback-container ut-flex ut-w-full ut-curpoint ut-text-accent"
          style="
            margin-left: -60px;
            margin-bottom: 1px;
            height: 40px;
            width: 138px;
          "
          @click="onCustomerFeedbackClick"
        >
          <div class="dt-icon-container" style="width: 40px; margin-left: 10px">
            <img
              class="dt-icon v5 s1"
              style="width: 40px"
              src="static/icons/customer-feedback.svg"
            />
          </div>
          <div class="ut-font-upper">{{ $t("feedback_title") }}</div>
        </div> -->
      </div>
    </v-navigation-drawer>
    <div>
      <!-- <v-text-field box label="Prepend inner" prepend-inner-icon="place"></v-text-field> -->
    </div>
    <v-content
      :class="{
        inactive: !this.$store.getters.mainNavActive,
        'module-container': true,
      }"
    >
       <v-layout class="dt-module-container" column align-center>
        <!-- <MainBreadcrumb
          :value="appDrawer"
          :class="{
            inactive: !this.$store.getters.mainNavActive,
          }"
        ></MainBreadcrumb> -->
        <router-view />
      </v-layout>
    </v-content>
    <!--<ConfirmationContainer></ConfirmationContainer>

    <template v-if="fileUploaderModalContainer">
      <v-dialog v-model="fileUploaderModal" persistent :width="762">
        <FileUploader
          :externalId="externalId"
          :externalTable="externalTable"
          @cancelled="onFileUploaderModalCancelled"
          @done="onFileAdded"
        />
      </v-dialog>
    </template>
    <template v-if="addContactRelationModalContainer">
      <v-dialog v-model="addContactRelationModal" persistent width="762">
        <AddContactRelation
          :externalId="externalId"
          :externalTable="externalTable"
          :externalName="externalName"
          :configType="configType"
          @contact_relation_added="onContactRelationAdd"
          @cancelled="addContactModalCancelled"
        >
        </AddContactRelation>
      </v-dialog>
    </template>
    <template v-if="dtTemplateListModalContainer">
      <v-dialog v-model="dtTemplateListModal" persistent width="1200">
        <DtTemplateList @cancelled="onCancel" />
      </v-dialog>
    </template>
    <template v-if="accountDetailsModalContainer">
      <v-dialog v-model="accountDetailsModal" persistent :width="'390'">
        <AccountDetails @cancelled="onAccountDetailsCancelled" />
      </v-dialog>
    </template>

    <template v-if="welcomeNoticeModalContainer">
      <v-dialog v-model="welcomeNoticeModal" persistent :width="bWidth">
        <WelcomeNotice
          :notices="notices"
          @cancelled="onWelcomeNoticeCancelled"
        />
      </v-dialog>
    </template>
    <template v-if="noticeModalContainer">
      <v-dialog v-model="noticeModal" persistent class="appanotice">
        <Notice :notice="selectedNotice" @cancelled="onNoticeCancelled" />
      </v-dialog>
    </template>

    <template v-if="customerFeedbackModalContainer">
      <v-dialog v-model="customerFeedbackModal" persistent width="580">
        <CustomerFeedback
          :notices="notices"
          @cancelled="customerFeedbackCancelled"
          @submitted="customerFeedbackSubmitted"
        />
      </v-dialog>
    </template> -->
  </v-app>
</template>

<script>
// import ConfirmationContainer from "../../dt-plugins/confirmation/confirmation-container";
// // import NotificationContainer from '../dt-plugins/notification/notification-container';
import LeftNavigationComponent from "./components/left-nav";
// import MainBreadcrumb from "@/components/main/main-breadcrumb.vue";
// import {
//   createModalMixin,
//   closeModalRoute,
//   openModalRoute2,
// } from "../../dt-plugins/modal/modal.mixin";
// import FileUploader from "../../dt-plugins/file-uploader/file-uploader";
// import AddContactRelation from "../../dt-plugins/add-contact-relation/add-contact-relation";
// import DtTemplateList from "../../dt-plugins/dt-template-list/dt-template-list.vue";

// import AddItemContactRelation from "../../dt-plugins/dbox-invoice-contact/add-contact-relation";

// import { fileAddedActionMapper } from "../../dt-plugins/file-uploader/action-mapper";
// import { getContactRelationAddedAction } from "../../dt-plugins/add-contact-relation/config-map";
// import { getFileAction } from "../../dt-plugins/file-uploader/config";

// import ModalContainer from "@dtplugins/modal/modal-container";
// import {
//   GetPath,
//   TabPath,
//   SubMenuPath,
//   ModulePath,
// } from "../../models/route.modal";
// import AccountDetails from "./account-details";
// import {
//   getDeviceInfo,
//   getPerformanceMemoryInfo,
//   getUTCTimeOffset,
//   isMobile,
//   JSONX,
//   sendMailNewTab,
//   wait,
// } from "../../utility";
// import WelcomeNotice from "./notice/welcome-notice";
// import Notice from "./notice/notice";
// import CustomerFeedback from "./customer-feedback/customer-feedback";

// import AIChatWindow from "./ai-chat/ai-chat-window.js";
// import * as AccTypes from "../../store/app/types";

// import {
//   waitForExistence,
//   _BandCamp,
//   _PLUGINDATA,
// } from "../../dt-plugins/module-plugins/bandcamp";
// import { MHTTPCL } from "../../services/http/http-client";
// import { i18n, toggleI18nMode } from "../../i18n/index";
// import Vue from "vue";
// import { format } from "date-fns";
// import { okMessage } from "../../dt-plugins/confirmation/confirmation-common";
// import { mapGetters, mapActions } from "vuex";
// import * as ActionTypes from "../../store/app/account/types";
export default {
  components: {
    // ModalContainer,
    LeftNavigationComponent,
    // MainBreadcrumb,
    // ConfirmationContainer,
    // FileUploader,
    // AddContactRelation,
    // DtTemplateList,
    // AddItemContactRelation,

    // AccountDetails,

    // WelcomeNotice,
    // CustomerFeedback,
    // AIChatWindow,
    // Notice,
  },
  data: function () {
    return {
      _observer: null,
      appThemeClass: {
        light: true,
      },
      clipped: false,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      bWidth: window.innerWidth,
      externalId: null,
      externalTable: null,
      externalName: null,
      configType: null,

      versionInfoVisible: false,
      buildinfo: {
        buildno: 0,
        checksum: "",
        date: "",
        hash: "",
        version: "",
      },

      userFeedBackItems: [
        {
          text: "Bug Report",
          value: "bug_report",
        },
        {
          text: "Feature Request",
          value: "feature_request",
        },
        {
          text: "User Experience Feedback",
          value: "user_experience_feedback",
        },
        {
          text: "Performance Feedback",
          value: "performance_feedback",
        },
        {
          text: "Usability Feedback",
          value: "usability_feedback",
        },
        {
          text: "Localization Feedback",
          value: "localization_feedback",
        },
        {
          text: "Documentation Feedback",
          value: "documentation_feedback",
        },
        {
          text: "General Feedback",
          value: "general_feedback",
        },
      ],

      aiChatBotWindow: false,
      selectedNotice: null,

      i18nKeysMode: "translate",
      i18nKeysLanguage: "en",
    };
  },
  mounted: function () {
    // this.domLoad();
    // if (isMobile()) {
    //   console.log("The user agent is mobile");
    //   this.$store.commit("SET_NAV_DRAWER", false);
    //   console.log(this.appDrawer);
    // } else {
    //   console.log("The user agent is not mobile");
    // }
  },
  mixins: [
    // createModalMixin("accountDetails"),
    // createModalMixin("addContactRelation"),
    // createModalMixin("dtTemplateList"),
    // createModalMixin("fileUploader"),
    // createModalMixin("welcomeNotice"),
    // createModalMixin("notice"),
    // createModalMixin("customerFeedback"),
  ],
  watch: {
    // $route: {
    //   immediate: true,
    //   handler: function (to, from) {
    //     this.externalId = to.query && to.query.external_id;
    //     this.externalTable = to.query && to.query.external_table;
    //     this.externalName = to.query && to.query.external_name;
    //     this.configType = to.query && to.query.config_type;
    //     // console.log("to", this._observer);
    //     if (this._observer) {
    //       this._observer.observe(document, { childList: true, subtree: true });
    //     }
    //     if (this.$store.getters.account) {
    //       console.log("Account Exists NO! ", this.$store.getters.account);
    //       console.log({ to });
    //       let { inapp_notices } = this.$store.getters.account;
    //       inapp_notices = inapp_notices.map((notice) => {
    //         notice.json_data =
    //           typeof notice.json_data == "string"
    //             ? JSON.parse(notice.json_data)
    //             : notice.json_data;
    //         return {
    //           ...notice,
    //           ...notice.json_data,
    //           isDisplay: notice.isDisplay ? notice.isDisplay : false,
    //         };
    //       });
    //       let [main, module, subMenu, param, subTab] = GetPath(to.path);
    //       let notice = null;
    //       if (module && subMenu && subTab) {
    //         notice = inapp_notices.find(
    //           (n) =>
    //             n.module == module &&
    //             n.sub_menu == subMenu &&
    //             TabPath(n.route_url) == subTab &&
    //             n.isDisplay == false
    //         );
    //       } else if (module && subMenu && !subTab) {
    //         notice = inapp_notices.find(
    //           (n) =>
    //             n.module == module &&
    //             SubMenuPath(n.route_url) == subMenu &&
    //             n.isDisplay == false
    //         );
    //       } else if (module && !subMenu) {
    //         notice = inapp_notices.find(
    //           (n) => n.module === module && n.isDisplay == false
    //         );
    //       }
    //       console.log("notice", notice);
    //       if (notice && !notice.isDisplay) {
    //         this.selectedNotice = notice;
    //         setTimeout(() => {
    //           this.$router.push({
    //             ...to,
    //             query: {
    //               modal: "notice",
    //             },
    //           });
    //         }, 1000);
    //       }
    //     }
    //   },
    // },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log({ vm });

      if (vm.$store.getters.account) {
        console.log("Account Exists! ", vm.$store.getters.account);

        let {
          display_notice_block,
          paywall_block,
          inapp_notices,
        } = vm.$store.getters.account;

        if (display_notice_block && to.query.modal !== "welcome_notice") {
          vm.$router.push({
            ...to,
            query: {
              modal: "welcome_notice",
            },
          });
        }
      }
    });
  },
  beforeDestroy() {
    if (this._observer) this._observer.disconnect();
  },
  computed: {
    // ...mapGetters({
    //   appDrawer: "appDrawer",
    // }),
    notices: function () {
      return this.$store?.getters?.account?.all_notices || [];
    },
    inAppNotices: function () {
      return this.$store?.getters?.account?.inapp_notices || [];
    },

    // drawer: {
    //   get () {
    //     return this.$store.getters.appDrawer;
    //   },
    //   set () {

    //   }
    // },
    mainNavClass: function () {
      return {
        "main-nav": true,
        inactive: !this.$store.getters.mainNavActive,
      };
    },
    items: function () {
      return this.$store.getters.appNavItems;
    },
    isLocal() {
      // console.log('this.$route?.name', this.$route?.name);
      // return true;
      return (
        /(localhost)|(192.168)/.test(window.location.origin) &&
        this.$route?.name == "catalog_artists/label_artist_id/tab"
      );
    },
  },
  methods: {
    // ...mapActions({
    //   [ActionTypes.UPDATE_INAPPNOTICE]: ActionTypes.UPDATE_INAPPNOTICE,
    // }),

    closeModalRoute: function () {
      closeModalRoute(this);
    },

    domLoad() {
      const params = JSON.parse(
        this.$store.getters.account.client.settings_generic_plugins
      );
      for (let i in params) {
        let elm = params[i];
        elm.parent = document.getElementById(elm.parent_id);
        this.addOvserver(elm);
      }
    },
    onCloseMainNav: function () {
      this.$store.dispatch("TOGGLE_SIDE_NAV");
    },
    onFileUploaderModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          external_id: undefined,
          external_table: undefined,
        },
      });
    },
    addContactModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          external_id: undefined,
          external_table: undefined,
        },
      });
    },
    onCancel: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          external_id: undefined,
        },
      });
    },
    onFileAdded: function ({ res, externalId, externalTable }) {
      const files = res.data.files;
      this.$store.dispatch(getFileAction(this.externalTable), {
        files,
        externalId,
        externalTable,
      });
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          external_id: undefined,
          external_table: undefined,
        },
      });
    },
    async addOvserver(params) {
      this._observer = new MutationObserver(function (mutations) {
        let el = document.getElementById(params.targeted_id);
        let element_selector = params.element_selector || "";
        if (el) {
          if (!element_selector) {
            this.disconnect();
            console.log("Plugin", params.name);
            let plugin_id = params.plugin_id || "";
            let code = params.code || "";
            if (code) {
              eval(code);
            } else if (plugin_id) {
              window.HttpClient.post("/plugins.pl", {
                section: "plugins",
                action: "plugin_code",
                plugin_id: plugin_id,
              }).then((pluginData) => {
                if (pluginData.data.v2_code) {
                  let { result } = JSONX.tryParse(pluginData.data.v2_code);
                  const { template, script, name } = result;
                  const tempCompile = Vue.compile(template);
                  const scriptEL = document.createElement("script");
                  scriptEL.innerHTML = script;
                  document.body.append(scriptEL);
                  const fragment = {
                    ...tempCompile,
                    ...window[name],
                  };
                  const dynamicThing = new Vue({
                    i18n,
                    render: (h) => h(fragment),
                  });
                  dynamicThing.$mount(el);
                }
              });
            }
          }
        }
      });
      this._observer.observe(params.parent, { childList: true, subtree: true });
    },

    async fetch(plugin_id) {
      const pluginData = await window.MHTTPCL.post("/plugins.pl", {
        section: "plugins",
        action: "plugin_code",
        plugin_id: plugin_id,
      });
      eval(pluginData.data.code);
    },
    onContactRelationAdd: function ({
      externalTable,
      external_id,
      payload,
      config_type,
    }) {
      const contactRelations = payload.contact_relations;

      // if (externalTable == "calendar_dates") {
      //   this.$store
      //     .dispatch(
      //       getContactRelationAddedAction(externalTable),
      //       {
      //         ...payload,
      //         external_id,
      //       }
      //     )
      //     .then((res) => {
      //       this.addContactModalCancelled();
      //     });
      // } else {
      //   this.$store
      //     .dispatch(
      //       getContactRelationAddedAction(externalTable),
      //       contactRelations
      //     )
      //     .then((res) => {
      //       this.addContactModalCancelled();
      //     });
      // }

      // Passing on ExternalId and externalTable to all ActionTypes ->
      console.log(config_type, ":::");
      if (config_type) {
        this.$store
          .dispatch(getContactRelationAddedAction(config_type), {
            ...payload,
            external_id,
            external_table: externalTable,
          })
          .then((res) => {
            this.addContactModalCancelled();
          });
      } else {
        this.$store
          .dispatch(getContactRelationAddedAction(externalTable), {
            ...payload,
            external_id,
            external_table: externalTable,
          })
          .then((res) => {
            this.addContactModalCancelled();
          });
      }
    },
    onNoticeCancelled: function (notice) {
      if (this.$store.getters.account && notice) {
        let { inapp_notices } = this.$store.getters.account;
        inapp_notices = inapp_notices.map((n) => {
          if (n.client_notice_id == notice.client_notice_id) {
            n.isDisplay = true;
          }
          return n;
        });
        this[ActionTypes.UPDATE_INAPPNOTICE](inapp_notices);
        setTimeout(() => {
          closeModalRoute(this);
        }, 100);
      }
    },
    onAccountDetailsCancelled: function () {
      closeModalRoute(this);
    },
    onWelcomeNoticeCancelled: function () {
      closeModalRoute(this);
    },
    async onVersionInfoKeyup(event) {
      console.log(event);
      const hostname =
        window.location.hostname == "localhost"
          ? "dev.berlin3.com"
          : window.location.hostname;

      if (event.shiftKey == true && event.code == "KeyV") {
        const buildinfo = await fetch(
          `https://${hostname}/v2_buildlog/buildinfo.json`
        ).then((res) => res.json());

        this.buildinfo = buildinfo;
        this.versionInfoVisible = !this.versionInfoVisible;

        console.log({ buildinfo: buildinfo });
      }
      if (event.shiftKey == true && event.code == "KeyI") {
        // If the user is on localhost or dev.berlin3.com
        if (
          window.location.origin == "http://localhost:8080" ||
          window.location.origin == "https://dev.berlin3.com"
        ) {
          toggleI18nMode();
        }
      }
      if (event.shiftKey == true && event.code == "KeyK") {
        // If the user is on localhost or dev.berlin3.com
        if (
          window.location.origin == "http://localhost:8080" ||
          window.location.origin == "https://dev.berlin3.com"
        ) {
          this.toggleIK8nKeysMode();
        }
      }
    },
    onUserFeedbackClick(event) {
      this.onUserFeedbackItemClick(this.userFeedBackItems[0]);
    },
    async onUserFeedbackItemClick(feedbackType) {
      const {
        userAgent,
        browserName,
        browserVersion,
        operatingSystem,
        screenInfo,
      } = getDeviceInfo();

      sendMailNewTab({
        mails: ["feedback@detailsdetails.eu"],
        subject: `${feedbackType.text} From ${this.$store?.getters?.account?.client?.clientID}`,
        body: `

       Dear Details Team,

        ${
          {
            feature_request: `I have a feature request that I believe would enhance the apps functionality and user experience.

        Feature Title:
        <Provide a clear and concise title for the feature request.>

        Description:
        <Briefly describe the feature you are requesting, focusing on the specific functionality or improvement you would like to see.>

        Use Case:
        <Describe a real-life scenario or use case where this feature would be valuable or beneficial.>

        Expected Benefits:
        <Explain the advantages or benefits that this feature would bring to users, such as increased efficiency, improved user experience, or time savings.>

        Priority:
        <Indicate the priority level of the feature request, using a predefined scale (e.g., high, medium, low) to indicate its relative importance.>

        Screenshots or Mockups (if applicable):
        <Attach any relevant screenshots, wireframes, or mockups that visually represent the desired feature. This can help the support team better understand your request.>

           `,
            bug_report: `I have found a bug in the app that I would like to report.

        Bug Summary:
        <Provide a concise and descriptive summary of the bug or issue encountered.>

        Bug Description:
        <Provide a detailed description of the bug, including the expected behavior and the actual behavior observed.>

        Steps to Reproduce:
        <Outline the exact steps needed to reproduce the bug, including any specific inputs or configurations used. This will help the developer replicate the issue.>

        Expected Result:
        <Describe the expected outcome or behavior when performing the steps mentioned above.>

        Actual Result:
        <Describe the actual outcome or behavior observed when performing the steps. Highlight any discrepancies or errors encountered.>

        Screenshots or Recordings:
        <Attach relevant screenshots or screen recordings that visually demonstrate the bug. This can help the developer better understand the issue.>
           
           `,
            user_experience_feedback: `I wanted to provide feedback on the user experience of Details App, specifically regarding ...
           
        Feedback Category:
        <Categorize your feedback into one of the following categories: Design, Navigation, Performance, Functionality, or Other.>

        Feedback Description:
        <Briefly describe the specific aspect of the user experience you are providing feedback on, focusing on what worked well or needs improvement.>

        Context:
        <Provide context or details about the specific scenario or use case in which you encountered the user experience issue or had a positive experience.>

        Impact:
        <Describe the impact the user experience has on your ability to use the web app effectively or efficiently.>

        Suggestions for Improvement:
        <Offer specific suggestions or ideas for improving the user experience, keeping in mind your concise descriptions.>

        Priority:
        <Indicate the priority level of your feedback, using a predefined scale (e.g., high, medium, low) to indicate its relative importance.>

        Screenshots or Examples (if applicable):
        <Attach any relevant screenshots or examples that visually demonstrate the specific user experience aspect you are providing feedback on.>
           `,
            performance_feedback: `I have feedback on the performance of Details App. Here are some observations and suggestions for improvement.
        Feedback Category:
        <Specify the category of performance feedback: Loading Time, Responsiveness, Resource Usage, or Other.>

        Feedback Description:
        <Briefly describe the specific aspect of performance you are providing feedback on, such as slow loading, laggy interface, high resource consumption, etc.>

        Context:
        <Provide context or details about the specific scenario or use case in which you encountered the performance issue or had performance concerns.>

        Impact:
        <Describe the impact the performance issue has on your ability to use the web app efficiently, accomplish tasks on time, or meet your workflow requirements.>

        Suggestions for Improvement:
        <Offer specific suggestions or ideas for improving the performance aspect mentioned, keeping in mind your concise descriptions.>

        Priority:
        <Indicate the priority level of your performance feedback, using a predefined scale (e.g., High, Medium, Low) to indicate its relative importance.>

        Environment Details:
        <Provide information about your device, model, version, RAM, CPU configuration and network conditions to help the support team understand the performance context better.>

        Additional Comments or Details:
        <Include any additional comments, details, or specific observations related to the performance feedback that can assist the support team in addressing the issue or considering performance optimizations.>
        
        Memory Information: ${getPerformanceMemoryInfo()}
            `,
            usability_feedback: `I wanted to provide feedback on the usability of Details App, specifically regarding <specific aspect of usability>.
        Feedback Category:
        <Categorize your feedback into one of the following categories: Navigation, Layout, Forms, Labels, Error Handling, or Other.>

        Feedback Description:
        <Briefly describe the specific aspect of usability you are providing feedback on, focusing on what worked well or needs improvement.>

        Context:
        <Provide context or details about the specific scenario or use case in which you encountered the usability issue or had a positive usability experience.>

        Impact:
        <Describe the impact the usabilappscreen recordings that visually demonstrate localization issue.>
           
           `,
            documentation_feedback: `I have some feedback about the documentation of the app that I would like to share.
        Documentation Title/Topic:
        <Specify the title or topic of the documentation you are providing feedback on.>

        Feedback Description:
        <Briefly describe the specific aspect of the documentation you are providing feedback on, such as clarity, completeness, organization, or accuracy.>

        Context:
        <Provide context or details about the specific section or use case where you encountered the documentation, or the specific problem you were trying to solve with the documentation.>

        Feedback Type:
        <Categorize your feedback into one of the following types: Confusing, Missing Information, Outdated, Error, or Other.>

        Suggestions for Improvement:
        <Offer specific suggestions or ideas for improving the documentation, such as adding examples, clarifying instructions, updating screenshots, providing more detailed explanations, or addressing specific errors or omissions.>

        Priority:
        <Indicate the priority level of your feedback, using a predefined scale (e.g., High, Medium, Low) to indicate its relative importance.>

             `,
            general_feedback:
              "I have some general feedback about the app that I would like to share.",
          }[feedbackType.value]
        }


        Window Info
        Module: ${this.$route.name}
        Route: ${this.$route.fullPath}
        Link: ${window.location.href}
        Report Time: ${format(new Date(), "YYYY-MM-DD hh:mm:ss a")}
        UTC: ${getUTCTimeOffset()}


        Device Info
        User Agent: ${userAgent}
        Browser Name: ${browserName}
        Browser Version: ${browserVersion}
        Operating System: ${operatingSystem}
        Screen Info: ${screenInfo}
        Zone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}


        From
        Username: ${this.$store.getters.account.user.user_name}
        Name: ${this.$store.getters.account.user.staff_fullname}
        Email: ${this.$store.getters.account.user.staff_email}
        Company: ${this.$store?.getters?.account?.client?.client_name}
        Address: ${this.$store?.getters?.account?.client?.client_address}
        Database: ${this.$store?.getters?.account?.client?.clientID}
        `,
      });
    },
    onCustomerFeedbackClick() {
      openModalRoute2(this, "customerFeedback");
    },
    customerFeedbackCancelled() {
      // console.log({'main-app.vue:776 customerFeedbackCancelled' : 1});
      closeModalRoute(this);
    },
    async customerFeedbackSubmitted() {
      // console.log({'main-app.vue:779 customerFeedbackSubmitted' : 1});
      closeModalRoute(this);
      await wait(200);
      okMessage("Thank you for your feedback!", "Success");
    },

    toggleIK8nKeysMode() {
      if (this.i18nKeysMode == "translate") {
        this.i18nKeysLanguage =
          this.$store.getters.systemLanguage.value == "keys"
            ? "en"
            : this.$store.getters.systemLanguage.value;
        this.$store.dispatch(AccTypes.UPDATE_SYSTEM_LANGUAGE, {
          text: "Devmode keys",
          value: "keys",
        });
        this.i18nKeysMode = "keys";
        document.body.classList.add("i18n-show-keys");
      } else if (this.i18nKeysMode == "keys") {
        document.body.classList.remove("i18n-show-keys");
        this.i18nKeysMode = "translate";
        this.$store.dispatch(
          AccTypes.UPDATE_SYSTEM_LANGUAGE,
          this.$store.getters.systemLanguagesTV.find(
            (lang) => lang.value == this.i18nKeysLanguage
          )
        );
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.container.fluid {
  background: white;
}

.dt-theme {
}

.module-container {
  background: var(--bc-secondary);
  color: var(--text-primary);
}

.navigation-drawer--fixed {
  padding-bottom: 0px;

  .version-info {
    min-width: 180px;
    min-height: 100px;

    margin: 4px 12px;
    margin-left: 10px;
    font-size: 10px;
    font-family: "Courier New", Courier, monospace;
    font-weight: 100;

    position: absolute;
    bottom: 40px;

    // Z Index is required so users can select this on top of the Version UIA
    z-index: 0;

    opacity: 0;

    &.visible {
      opacity: 1;
    }

    table {
      tr {
        td:first-child {
          text-align: left;
          color: var(--text-accent);
          min-width: 60px;
        }

        td:nth-child(2) {
          max-width: 110px;

          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
  app &.inactive {
    .feedback-container {
      border-top-right-radius: 8px;
      background: #f6f6f6;
    }
  }
}

.ai-chat-container {
  // background: white;
  position: absolute;
  bottom: 36px;
  z-index: 90;
  right: 36px;

  .ai-chat-button {
    background: white;

    box-shadow: 0px 3px 30px #00000033;
    width: 64px;
    height: 64px;
    border-radius: 45px;

    display: flex;
    justify-content: center;

    cursor: pointer;

    &:hover {
      background: #f6f6f6;
    }

    &:active,
    &:focus {
      background: #f8f8f8;
    }

    &.delete-button {
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
  }
}
</style>

<style lang="scss">
// Animation Time for AI Chat Window
$animation-time: 0.35s;

.maximize-window-enter-to {
  opacity: 1;
  transition: opacity $animation-time ease-in-out, transform $animation-time ease-in-out;

  transform: scale(1) translateY(0px);
}

.maximize-window-enter {
  opacity: 0;
  transform: translateY(388px) translateX(168px) scale(0.1);
}

.maximize-window-leave-to {
  opacity: 0;
  transition: opacity $animation-time ease-in-out, transform $animation-time ease-in-out;
  transform: translateY(388px) translateX(168px) scale(0.1);
}

.maximize-window-leave {
  opacity: 1;
  // transform: translateY(388px) translateX(168px) scale(0.1);

  transform: scale(1) translateY(0px);
}

.maximize-window-element {
  transform: scale(1) translateY(0px);
}

// maximize-icon

.maximize-icon-enter {
  opacity: 0;
  transform: translateY(-82px) translateX(-44px);
}

.maximize-icon-enter-to {
  opacity: 1;
  transition: opacity $animation-time ease-in-out, transform $animation-time ease-in-out;
  // transition-delay: 0.01s;
  transform: scale(1) translateY(0px);
}

.maximize-icon-leave {
  opacity: 1;
  transform: scale(1) translateY(0px);
}

.maximize-icon-leave-to {
  opacity: 0;
  transition: opacity $animation-time ease-in-out, transform $animation-time ease-in-out;
  transform: translateY(-82px) translateX(-44px);
}

.maximize-icon-element {
  transform: scale(1) translateY(0px);
}
// fade-slide-down
.fade-slide-down-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-slide-down-enter-to {
  opacity: 1;
  transform: translateY(0);
  transition: all $animation-time ease-out;
}

.fade-slide-down-leave {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  transition: all $animation-time ease-out;
}
</style>
